import { useStore } from "@/composable/useStore"
import { WorkspaceTemplate } from "@/types/workspace"

export const getTemplate = (space: WorkspaceTemplate) => {
  const { spaceModule } = useStore()

  if (space.templateId) {
    const template = spaceModule.templates.find(t => space.templateId === t.id)
    return template?.title as string
  }

  return null
}
